import { useEffect } from 'react';

/**
 * 为页面上所有 Ant Design Modal（含 Modal.confirm）启用标题栏拖动。
 * 在 App 根级挂载一次即可，无需逐个 Modal 改代码。
 */
export function useGlobalDraggableModal(): void {
  useEffect(() => {
    let drag:
      | {
          modal: HTMLElement;
          startX: number;
          startY: number;
          origLeft: number;
          origTop: number;
        }
      | null = null;

    const pinModalPosition = (modal: HTMLElement) => {
      const rect = modal.getBoundingClientRect();
      modal.style.position = 'fixed';
      modal.style.left = `${rect.left}px`;
      modal.style.top = `${rect.top}px`;
      modal.style.margin = '0';
      modal.style.transform = 'none';
    };

    const onMouseDown = (e: MouseEvent) => {
      if (e.button !== 0) return;
      const target = e.target as HTMLElement;
      if (target.closest('.ant-modal-close') || target.closest('button,a,input,textarea,select')) {
        return;
      }
      const header = target.closest('.ant-modal-header');
      if (!header) return;
      const modal = header.closest('.ant-modal') as HTMLElement | null;
      if (!modal) return;

      pinModalPosition(modal);
      const rect = modal.getBoundingClientRect();
      drag = {
        modal,
        startX: e.clientX,
        startY: e.clientY,
        origLeft: rect.left,
        origTop: rect.top,
      };
      e.preventDefault();
      document.body.style.userSelect = 'none';
    };

    const onMouseMove = (e: MouseEvent) => {
      if (!drag) return;
      const dx = e.clientX - drag.startX;
      const dy = e.clientY - drag.startY;
      const w = drag.modal.offsetWidth;
      const h = drag.modal.offsetHeight;
      const pad = 8;
      const left = Math.max(pad, Math.min(drag.origLeft + dx, window.innerWidth - w - pad));
      const top = Math.max(pad, Math.min(drag.origTop + dy, window.innerHeight - h - pad));
      drag.modal.style.left = `${left}px`;
      drag.modal.style.top = `${top}px`;
    };

    const onMouseUp = () => {
      if (!drag) return;
      drag = null;
      document.body.style.userSelect = '';
    };

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      document.body.style.userSelect = '';
    };
  }, []);
}
